module.exports = __webpack_public_path__ + "static/media/chart-54k-v2--black.3b08d96f.svg";